import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "priority", "type", "color", "height", "fullScreen", "active", "extraClass", "spinner", "hidden", "style"],
  _excluded2 = ["isValidFunction", "disabled"];
import React from "react";
import { mergeClasses } from "@magento/venia-ui/lib/classify";
import defaultClasses from "./button.css";
import myClasses from "./button.module.scss";
var getButtonClassColor = color => "mi_button_".concat(color);
var getButtonClassHeight = height => "mi_button_".concat(height);
var Button = props => {
  var {
      children,
      classes: propClasses,
      priority,
      type,
      color,
      height,
      fullScreen,
      active,
      extraClass,
      spinner,
      hidden,
      style
    } = props,
    restProps = _objectWithoutProperties(props, _excluded);
  var classes = mergeClasses(myClasses, defaultClasses, propClasses);
  var rootClassName = classes["mi_button"];
  var buttonColor = classes[getButtonClassColor(color)];
  var buttonHeight = classes[getButtonClassHeight(height)];
  var fullScreenClass = fullScreen ? classes["mi_button_fullscreen"] : "";
  var activeClass = active ? classes["mi_button_active"] : "";
  var hiddenClass = hidden ? classes["mi_button_hidden"] : "";
  return /*#__PURE__*/React.createElement("button", _extends({
    className: "".concat(rootClassName, " ").concat(fullScreenClass, " ").concat(activeClass, " ").concat(buttonColor, " ").concat(buttonHeight, " ").concat(extraClass, " uk-box-shadow-medium ").concat(hiddenClass),
    type: type,
    style: style
  }, restProps), spinner ? spinner : /*#__PURE__*/React.createElement("span", {
    className: classes.content
  }, children));
};
Button.defaultProps = {
  priority: "normal",
  type: "button",
  color: "primary",
  height: "small",
  fullScreen: false,
  active: false,
  extraClass: ""
};
export var ButtonValidated = _ref => {
  var {
      isValidFunction,
      disabled
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded2);
  return /*#__PURE__*/React.createElement(Button, _extends({
    disabled: !isValidFunction()
  }, props));
};
export default Button;